import { StateCreator } from 'zustand'

interface RecentView {
    viewId: number
    viewName: string
    pathUrl: string
    moduleName: string
    timestamp: number
}

export interface UserSlice {
    recentViews: RecentView[]
    favoriteModules: string[]
    allowedOperations: Record<string, string[]>
    addRecentView: (view: Omit<RecentView, 'timestamp'>) => void
    toggleFavoriteModule: (moduleId: string) => void
    setAllowedOperations: (pathUrl: string, operations: string[]) => void
    getAllowedOperations: (pathUrl: string) => string[]
}

export const createUserSlice: StateCreator<UserSlice> = (set, get) => ({
    recentViews: [],
    favoriteModules: [],
    allowedOperations: {},
    addRecentView: (view) => {
        set((state) => ({
            recentViews: [
                { ...view, timestamp: Date.now() },
                ...state.recentViews.filter((v) => v.viewId !== view.viewId)
            ].slice(0, 5)
        }))
    },
    toggleFavoriteModule: (moduleId) => {
        set((state) => ({
            favoriteModules: state.favoriteModules.includes(moduleId)
                ? state.favoriteModules.filter((id) => id !== moduleId)
                : [...state.favoriteModules, moduleId]
        }))
    },
    setAllowedOperations: (pathUrl, operations) => {
        set((state) => ({
            allowedOperations: {
                ...state.allowedOperations,
                [pathUrl]: operations
            }
        }))
    },
    getAllowedOperations: (pathUrl) => get().allowedOperations[pathUrl] || []
})
